// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Premium Dark Dashboard Styles */

/* Variables now inherited from index.css */

.dashboard {
  min-height: 100vh;
  background: var(--dashboard-bg);
  font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;
  color: var(--text-main);
  position: relative;
  overflow: hidden;
}

/* Animated Background */
.dashboard::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background:
    radial-gradient(circle at 10% 10%, rgba(99, 102, 241, 0.15) 0%, transparent 50%),
    radial-gradient(circle at 90% 90%, rgba(236, 72, 153, 0.1) 0%, transparent 50%);
  z-index: 0;
  pointer-events: none;
}

/* Header */
.dashboard-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;
  background: var(--header-bg);
  backdrop-filter: blur(12px);
  border-bottom: var(--glass-border);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 50;
  height: 70px;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 1.5rem;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.sidebar-toggle {
  background: transparent;
  border: var(--glass-border);
  color: var(--text-muted);
  font-size: 1.25rem;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 8px;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.sidebar-toggle:hover {
  background: var(--surface-light);
  color: white;
}

.dashboard-header h1 {
  font-size: 1.25rem;
  font-weight: 700;
  background: var(--gradient-heading);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  margin: 0;
  letter-spacing: -0.01em;
}

/* Dashboard Body */
.dashboard-body {
  display: flex;
  margin-top: 70px;
  height: calc(100vh - 70px);
  position: relative;
  z-index: 10;
}

/* Sidebar */
.dashboard-sidebar {
  width: var(--sidebar-width);
  background: var(--sidebar-bg);
  border-right: var(--glass-border);
  display: flex;
  flex-direction: column;
  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 40;
}

.dashboard-sidebar.collapsed {
  width: var(--sidebar-collapsed-width);
}

.sidebar-nav {
  padding: 1.5rem 0.75rem;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.nav-item {
  display: flex;
  align-items: center;
  padding: 0.75rem 1rem;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  color: var(--text-muted);
  font-weight: 500;
  white-space: nowrap;
  gap: 1rem;
}

.nav-item:hover {
  background: var(--surface-light);
  color: var(--text-main);
  transform: translateX(4px);
}

.nav-item.active {
  background: linear-gradient(135deg, rgba(99, 102, 241, 0.2) 0%, rgba(168, 85, 247, 0.2) 100%);
  color: #a5b4fc;
  border: 1px solid rgba(99, 102, 241, 0.3);
  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.1);
}

.nav-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  position: relative;
}

/* Unique Icon Colors & Glows */
.connections-icon {
  color: #6366f1;
}

.nav-item:hover .connections-icon,
.nav-item.active .connections-icon {
  background: rgba(99, 102, 241, 0.15);
  box-shadow: 0 0 15px rgba(99, 102, 241, 0.3);
}

.migrations-icon {
  color: #a855f7;
}

.nav-item:hover .migrations-icon,
.nav-item.active .migrations-icon {
  background: rgba(168, 85, 247, 0.15);
  box-shadow: 0 0 15px rgba(168, 85, 247, 0.3);
}

.monitor-icon {
  color: #ec4899;
}

.nav-item:hover .monitor-icon,
.nav-item.active .monitor-icon {
  background: rgba(236, 72, 153, 0.15);
  box-shadow: 0 0 15px rgba(236, 72, 153, 0.3);
}

.nav-item:hover .nav-icon {
  transform: scale(1.2) rotate(5deg);
}

.nav-item.active .nav-icon {
  transform: scale(1.1);
}

.dashboard-sidebar.collapsed .nav-item {
  padding: 0.75rem;
  justify-content: center;
  gap: 0;
}

.dashboard-sidebar.collapsed .nav-item:hover {
  transform: scale(1.05);
}

.nav-label {
  font-size: 0.95rem;
  transition: opacity 0.3s, transform 0.3s;
}

.dashboard-sidebar.collapsed .nav-label {
  opacity: 0;
  width: 0;
  transform: translateX(-10px);
  pointer-events: none;
  visibility: hidden;
}

/* Sidebar Footer */
.sidebar-footer {
  padding: 1.5rem;
  border-top: var(--glass-border);
}

.dashboard-sidebar.collapsed .sidebar-footer {
  padding: 1.5rem 0.5rem;
  display: flex;
  justify-content: center;
}

.system-status {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 0.85rem;
  color: var(--text-muted);
}

.dashboard-sidebar.collapsed .system-status span {
  display: none;
}

.status-indicator {
  width: 8px;
  height: 8px;
  background: #10b981;
  border-radius: 50%;
  box-shadow: 0 0 10px rgba(16, 185, 129, 0.5);
  animation: pulse 2s infinite;
}

/* Main Content */
.dashboard-main {
  flex: 1 1;
  padding: 2rem;
  overflow-y: auto;
  background: radial-gradient(circle at top center, rgba(30, 41, 59, 0.3), transparent);
}

/* Buttons */
.btn-secondary {
  padding: 0.6rem 1.25rem;
  background: rgba(255, 255, 255, 0.05);
  border: var(--glass-border);
  color: var(--text-main);
  border-radius: 10px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.btn-secondary:hover {
  background: var(--surface-light);
  border-color: rgba(255, 255, 255, 0.2);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.btn-secondary:active {
  transform: translateY(0) scale(0.98);
}

/* Notifications */
.notification {
  position: fixed;
  top: 80px;
  /* Below header */
  right: 2rem;
  padding: 1rem 1.5rem;
  border-radius: 12px;
  background: rgba(15, 23, 42, 0.9);
  backdrop-filter: blur(10px);
  border: var(--glass-border);
  color: white;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);
  z-index: 100;
  animation: slideIn 0.3s ease-out;
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.notification.info {
  border-left: 4px solid #3b82f6;
}

.notification.success {
  border-left: 4px solid #10b981;
}

.notification.error {
  border-left: 4px solid #ef4444;
}

@keyframes slideIn {
  from {
    transform: translateX(100%);
    opacity: 0;
  }

  to {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 1;
  }

  50% {
    transform: scale(1.1);
    opacity: 0.7;
  }

  100% {
    transform: scale(1);
    opacity: 1;
  }
}

/* Responsive */
@media (max-width: 768px) {
  .dashboard-sidebar {
    position: absolute;
    height: 100%;
    transform: translateX(-100%);
  }

  .dashboard-sidebar.collapsed {
    /* reused 'collapsed' class to mean 'closed' on mobile effectively */
    transform: translateX(0);
    width: 100%;
  }

  /* Just basic mobile responsiveness tweaks */
  .dashboard-body {
    flex-direction: column;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Dashboard.css"],"names":[],"mappings":"AAAA,kCAAkC;;AAElC,2CAA2C;;AAE3C;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,qDAAqD;EACrD,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;mFAEiF;EACjF,UAAU;EACV,oBAAoB;AACtB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;EAC5B,2BAA2B;EAC3B,kCAAkC;EAClC,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;EACnC,6BAA6B;EAC7B,qBAAqB;EACrB,oCAAoC;EACpC,SAAS;EACT,uBAAuB;AACzB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,WAAW;AACb;;AAEA,YAAY;AACZ;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,iCAAiC;EACjC,aAAa;EACb,sBAAsB;EACtB,mDAAmD;EACnD,WAAW;AACb;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,uBAAuB;EACvB,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;EACf,iDAAiD;EACjD,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,6FAA6F;EAC7F,cAAc;EACd,yCAAyC;EACzC,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,4DAA4D;EAC5D,kBAAkB;AACpB;;AAEA,+BAA+B;AAC/B;EACE,cAAc;AAChB;;AAEA;;EAEE,oCAAoC;EACpC,4CAA4C;AAC9C;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,oCAAoC;EACpC,4CAA4C;AAC9C;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,oCAAoC;EACpC,4CAA4C;AAC9C;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,MAAM;AACR;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,4BAA4B;EAC5B,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,4CAA4C;EAC5C,4BAA4B;AAC9B;;AAEA,iBAAiB;AACjB;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,qFAAqF;AACvF;;AAEA,YAAY;AACZ;EACE,uBAAuB;EACvB,qCAAqC;EACrC,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,iDAAiD;EACjD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,sCAAsC;EACtC,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,oCAAoC;AACtC;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,SAAS;EACT,iBAAiB;EACjB,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,iCAAiC;EACjC,2BAA2B;EAC3B,2BAA2B;EAC3B,YAAY;EACZ,0CAA0C;EAC1C,YAAY;EACZ,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;;EAEA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,UAAU;EACZ;;EAEA;IACE,qBAAqB;IACrB,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA,eAAe;AACf;EACE;IACE,kBAAkB;IAClB,YAAY;IACZ,4BAA4B;EAC9B;;EAEA;IACE,oEAAoE;IACpE,wBAAwB;IACxB,WAAW;EACb;;EAEA,4CAA4C;EAC5C;IACE,sBAAsB;EACxB;AACF","sourcesContent":["/* Premium Dark Dashboard Styles */\r\n\r\n/* Variables now inherited from index.css */\r\n\r\n.dashboard {\r\n  min-height: 100vh;\r\n  background: var(--dashboard-bg);\r\n  font-family: 'Plus Jakarta Sans', 'Inter', sans-serif;\r\n  color: var(--text-main);\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n\r\n/* Animated Background */\r\n.dashboard::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background:\r\n    radial-gradient(circle at 10% 10%, rgba(99, 102, 241, 0.15) 0%, transparent 50%),\r\n    radial-gradient(circle at 90% 90%, rgba(236, 72, 153, 0.1) 0%, transparent 50%);\r\n  z-index: 0;\r\n  pointer-events: none;\r\n}\r\n\r\n/* Header */\r\n.dashboard-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 1rem 2rem;\r\n  background: var(--header-bg);\r\n  backdrop-filter: blur(12px);\r\n  border-bottom: var(--glass-border);\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  z-index: 50;\r\n  height: 70px;\r\n}\r\n\r\n.header-left {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 1.5rem;\r\n}\r\n\r\n.header-right {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 1rem;\r\n}\r\n\r\n.sidebar-toggle {\r\n  background: transparent;\r\n  border: var(--glass-border);\r\n  color: var(--text-muted);\r\n  font-size: 1.25rem;\r\n  cursor: pointer;\r\n  padding: 0.5rem;\r\n  border-radius: 8px;\r\n  transition: all 0.3s ease;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.sidebar-toggle:hover {\r\n  background: var(--surface-light);\r\n  color: white;\r\n}\r\n\r\n.dashboard-header h1 {\r\n  font-size: 1.25rem;\r\n  font-weight: 700;\r\n  background: var(--gradient-heading);\r\n  -webkit-background-clip: text;\r\n  background-clip: text;\r\n  -webkit-text-fill-color: transparent;\r\n  margin: 0;\r\n  letter-spacing: -0.01em;\r\n}\r\n\r\n/* Dashboard Body */\r\n.dashboard-body {\r\n  display: flex;\r\n  margin-top: 70px;\r\n  height: calc(100vh - 70px);\r\n  position: relative;\r\n  z-index: 10;\r\n}\r\n\r\n/* Sidebar */\r\n.dashboard-sidebar {\r\n  width: var(--sidebar-width);\r\n  background: var(--sidebar-bg);\r\n  border-right: var(--glass-border);\r\n  display: flex;\r\n  flex-direction: column;\r\n  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n  z-index: 40;\r\n}\r\n\r\n.dashboard-sidebar.collapsed {\r\n  width: var(--sidebar-collapsed-width);\r\n}\r\n\r\n.sidebar-nav {\r\n  padding: 1.5rem 0.75rem;\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.nav-item {\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 0.75rem 1rem;\r\n  border-radius: 12px;\r\n  cursor: pointer;\r\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n  color: var(--text-muted);\r\n  font-weight: 500;\r\n  white-space: nowrap;\r\n  gap: 1rem;\r\n}\r\n\r\n.nav-item:hover {\r\n  background: var(--surface-light);\r\n  color: var(--text-main);\r\n  transform: translateX(4px);\r\n}\r\n\r\n.nav-item.active {\r\n  background: linear-gradient(135deg, rgba(99, 102, 241, 0.2) 0%, rgba(168, 85, 247, 0.2) 100%);\r\n  color: #a5b4fc;\r\n  border: 1px solid rgba(99, 102, 241, 0.3);\r\n  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.1);\r\n}\r\n\r\n.nav-icon {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 32px;\r\n  height: 32px;\r\n  border-radius: 8px;\r\n  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);\r\n  position: relative;\r\n}\r\n\r\n/* Unique Icon Colors & Glows */\r\n.connections-icon {\r\n  color: #6366f1;\r\n}\r\n\r\n.nav-item:hover .connections-icon,\r\n.nav-item.active .connections-icon {\r\n  background: rgba(99, 102, 241, 0.15);\r\n  box-shadow: 0 0 15px rgba(99, 102, 241, 0.3);\r\n}\r\n\r\n.migrations-icon {\r\n  color: #a855f7;\r\n}\r\n\r\n.nav-item:hover .migrations-icon,\r\n.nav-item.active .migrations-icon {\r\n  background: rgba(168, 85, 247, 0.15);\r\n  box-shadow: 0 0 15px rgba(168, 85, 247, 0.3);\r\n}\r\n\r\n.monitor-icon {\r\n  color: #ec4899;\r\n}\r\n\r\n.nav-item:hover .monitor-icon,\r\n.nav-item.active .monitor-icon {\r\n  background: rgba(236, 72, 153, 0.15);\r\n  box-shadow: 0 0 15px rgba(236, 72, 153, 0.3);\r\n}\r\n\r\n.nav-item:hover .nav-icon {\r\n  transform: scale(1.2) rotate(5deg);\r\n}\r\n\r\n.nav-item.active .nav-icon {\r\n  transform: scale(1.1);\r\n}\r\n\r\n.dashboard-sidebar.collapsed .nav-item {\r\n  padding: 0.75rem;\r\n  justify-content: center;\r\n  gap: 0;\r\n}\r\n\r\n.dashboard-sidebar.collapsed .nav-item:hover {\r\n  transform: scale(1.05);\r\n}\r\n\r\n.nav-label {\r\n  font-size: 0.95rem;\r\n  transition: opacity 0.3s, transform 0.3s;\r\n}\r\n\r\n.dashboard-sidebar.collapsed .nav-label {\r\n  opacity: 0;\r\n  width: 0;\r\n  transform: translateX(-10px);\r\n  pointer-events: none;\r\n  visibility: hidden;\r\n}\r\n\r\n/* Sidebar Footer */\r\n.sidebar-footer {\r\n  padding: 1.5rem;\r\n  border-top: var(--glass-border);\r\n}\r\n\r\n.dashboard-sidebar.collapsed .sidebar-footer {\r\n  padding: 1.5rem 0.5rem;\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\n.system-status {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.75rem;\r\n  font-size: 0.85rem;\r\n  color: var(--text-muted);\r\n}\r\n\r\n.dashboard-sidebar.collapsed .system-status span {\r\n  display: none;\r\n}\r\n\r\n.status-indicator {\r\n  width: 8px;\r\n  height: 8px;\r\n  background: #10b981;\r\n  border-radius: 50%;\r\n  box-shadow: 0 0 10px rgba(16, 185, 129, 0.5);\r\n  animation: pulse 2s infinite;\r\n}\r\n\r\n/* Main Content */\r\n.dashboard-main {\r\n  flex: 1;\r\n  padding: 2rem;\r\n  overflow-y: auto;\r\n  background: radial-gradient(circle at top center, rgba(30, 41, 59, 0.3), transparent);\r\n}\r\n\r\n/* Buttons */\r\n.btn-secondary {\r\n  padding: 0.6rem 1.25rem;\r\n  background: rgba(255, 255, 255, 0.05);\r\n  border: var(--glass-border);\r\n  color: var(--text-main);\r\n  border-radius: 10px;\r\n  font-size: 0.9rem;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.btn-secondary:hover {\r\n  background: var(--surface-light);\r\n  border-color: rgba(255, 255, 255, 0.2);\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.btn-secondary:active {\r\n  transform: translateY(0) scale(0.98);\r\n}\r\n\r\n/* Notifications */\r\n.notification {\r\n  position: fixed;\r\n  top: 80px;\r\n  /* Below header */\r\n  right: 2rem;\r\n  padding: 1rem 1.5rem;\r\n  border-radius: 12px;\r\n  background: rgba(15, 23, 42, 0.9);\r\n  backdrop-filter: blur(10px);\r\n  border: var(--glass-border);\r\n  color: white;\r\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);\r\n  z-index: 100;\r\n  animation: slideIn 0.3s ease-out;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.75rem;\r\n}\r\n\r\n.notification.info {\r\n  border-left: 4px solid #3b82f6;\r\n}\r\n\r\n.notification.success {\r\n  border-left: 4px solid #10b981;\r\n}\r\n\r\n.notification.error {\r\n  border-left: 4px solid #ef4444;\r\n}\r\n\r\n@keyframes slideIn {\r\n  from {\r\n    transform: translateX(100%);\r\n    opacity: 0;\r\n  }\r\n\r\n  to {\r\n    transform: translateX(0);\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n@keyframes pulse {\r\n  0% {\r\n    transform: scale(1);\r\n    opacity: 1;\r\n  }\r\n\r\n  50% {\r\n    transform: scale(1.1);\r\n    opacity: 0.7;\r\n  }\r\n\r\n  100% {\r\n    transform: scale(1);\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n/* Responsive */\r\n@media (max-width: 768px) {\r\n  .dashboard-sidebar {\r\n    position: absolute;\r\n    height: 100%;\r\n    transform: translateX(-100%);\r\n  }\r\n\r\n  .dashboard-sidebar.collapsed {\r\n    /* reused 'collapsed' class to mean 'closed' on mobile effectively */\r\n    transform: translateX(0);\r\n    width: 100%;\r\n  }\r\n\r\n  /* Just basic mobile responsiveness tweaks */\r\n  .dashboard-body {\r\n    flex-direction: column;\r\n  }\r\n}\r"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
